import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ShellComponent } from './shell.component';

@NgModule({
  imports: [CommonModule],
  declarations: [ShellComponent],
})
export class ShellModule {}
